<div class="modal auth-modal" data-testid="auth-modal-container">
  <div class="modal__header" data-testid="auth-modal-header">
    <h2 class="modal__title" data-testid="auth-modal-title">{{ viewTitle() }}</h2>

    <button class="modal__close" type="button" (click)="onClose()" data-testid="auth-modal-close-button" aria-label="Close modal">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal__content" data-testid="auth-modal-content">
    @switch (currentView()) { @case ('login') {
    <wil-login-modal-content (navigate)="switchView($event)" data-testid="auth-modal-login-content"> </wil-login-modal-content>
    } @case ('register') { @if (isPendingWheelRegistration) { @if (isDownloadImageRegistration) {
    <section class="auth-modal__download-section" data-testid="auth-modal-download-section">
      <wil-cta-button
        class="btn btn--primary auth-modal__download-button"
        ctaText="Download as an image"
        (ctaClick)="onDownloadImage()"
        [loading]="isDownloadingImage()"
        [disabled]="isDownloadingImage()"
        [style]="'primary'"
        size="large"
        data-testid="auth-modal-download-button"
      ></wil-cta-button>
      @if (hasDownloadImageError()) {
      <p class="auth-modal__download-error" role="alert" data-testid="auth-modal-download-error">Something went wrong. Please try again.</p>
      }
    </section>
    }
    <wil-free-plan-registration-modal-content
      [subheading]="
        isDownloadImageRegistration ? 'Or save your data with a Free account. No credit card required.' : 'No credit card required'
      "
      (navigateToLogin)="switchView('login')"
      data-testid="auth-modal-free-plan-registration-content"
    ></wil-free-plan-registration-modal-content>
    } @else {
    <wil-plan-select-modal-content
      (navigateBack)="switchView('login')"
      (selectPlan)="onPlanSelected($event)"
      (navigateToLanding)="onClose()"
      data-testid="auth-modal-plan-select-content"
    >
    </wil-plan-select-modal-content>
    } } @case ('forgotPassword') {
    <wil-forgot-password-modal-content (navigate)="switchView($event)" data-testid="auth-modal-forgot-password-content">
    </wil-forgot-password-modal-content>
    } }
  </div>
</div>
